import React from 'react'
import QAPVars from 'qap/vars'

type IconProps = {
  reverse?: boolean,
}

export const QAPIconMark = (props: IconProps) => {
  const { reverse } = props
  const {
    corporationIconLight: light,
    corporationIconDark: dark,
    corporationIconHero: other,
    white,
  } = QAPVars

  return (
    <g>
      <linearGradient id='gradientFill' gradientUnits='userSpaceOnUse' x1='7142.6909' y1='53.2588' x2='7221.353' y2='131.0372' gradientTransform='matrix(-1 0 0 1 7777.2554 0)'>
        <stop offset='0' style={{ 'stopColor': light }} />
        <stop offset='1' style={{ 'stopColor': other }} />
      </linearGradient>

      <path fill={reverse ? white : 'url(#gradientFill)'} d='M540.1,64.9c8,0.9,14.3,6.5,21.5,9.7c5.1,2.2,10.4,3.4,15.8,2c4.5-1.1,8.5-3.6,12.5-5.8
      c1.4-0.8,2.9-1.6,4.4-2.4c2.9-2.2,6.5-3.5,10.2-3.5c0.9,0,1.8,0.1,2.7,0.2c0.7,0.1,1.4,0.2,2.1,0.3c4.2,1,7.8,3.8,10.1,7.4
      c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.2c0.2,0.4,0.5,0.7,0.7,1.1c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.3,0.3,0.6,0.4,1
      c0.1,0.2,0.1,0.3,0.2,0.5c0.6,1.6,1,3.3,1.1,5c0,0,0,0.1,0,0.1c0,0.2,0,0.5,0,0.7c0,0.2,0,0.4,0,0.7c0,1.3-0.1,2.6-0.4,3.9
      c-1.1,4.8-4.5,9.1-6.7,13.6c-3,6.1-5.3,12.7-4.3,19.6c0.5,3.9,2.1,7.5,4,10.9c1.9,3.3,3.9,6.5,5.4,9.8c1.7,4,2.6,8.1,1.1,12.9
      c-1.3,4-4.2,7.7-7.9,9.8c-11.1,6.3-27.2-2.9-25.8-16.1c0.9-8,6.5-14.3,9.7-21.5c2.2-5.1,3.4-10.4,2-15.8
      c-3.5-14.2-17.1-23.6-31.7-21.5c-3.9,0.5-7.5,2.1-10.9,4c-3.3,1.9-6.5,3.9-9.8,5.4c-4,1.7-8.1,2.6-12.9,1.1c-4-1.3-7.7-4.2-9.8-7.9
      C517.7,79.6,526.9,63.5,540.1,64.9z' />
      <circle fill={reverse ? white : dark} cx='539.1' cy='146.3' r='17.2' />
      <circle fill={reverse ? white : light} cx='605' cy='23.8' r='17.2' />
      <circle fill={reverse ? white : other} cx='657.9' cy='115' r='17.2' />
    </g>
  )
}

const QAPIcon = (props: IconProps) => {
  const { reverse } = props

  return (
    <svg viewBox='500 0 190 190' data-testid='QAPIcon'>
      <QAPIconMark reverse={reverse} />
    </svg>
  )
}

export default QAPIcon
